import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import useBodyClass from "../../actions/toggleBodyClass";

import { useMediaQuery } from "react-responsive";

import { Logo } from "../logo/Logo";
import { Menu } from "../menu/Menu";
import { Navigation } from "../icons/Navigation";
import { Close } from "../icons/Close";
import { DiscordIcon } from "../discord/DiscordIcon";
import { DiscordLink } from "../discord/DiscordLink";
import Copyright from "../copyright/Copyright";

import classNames from "classnames/bind";
import styles from "./Header.module.scss";


export const Header = ({ isHome, links , type}) => {

    const Tag = isHome ? "h1" : "div";

    const isLarge = useMediaQuery({ query: "(min-width: 1280px)" });

    let width = 140;
    let height = 26;

    if(isLarge) {
        width = 280;
        height = 53;
    }

    const [toggle, setToggle] = useState(false);

    const triggerToggle = () => {
        setToggle( !toggle );
        console.log(toggle);
    }

    useBodyClass(`menu-${toggle}`);

    let isTransparent;

    if (["post", "podcast", "review", "page"].indexOf(type) >= 0) {
        isTransparent = true;
    }

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        isTransparent && "transparent",
        type,
    );

    return (
        <header className={classes}>
            <Tag className={cx("logo", toggle && "menuopen")}>
                <Link
                    to="/"
                >
                    <Logo
                        color={"#FFF"}
                        width={width}
                        height={height}
                    />
                </Link>
            </Tag>

            <div
                className={cx(
                    "button", 
                    toggle ? styles.buttonClose : styles.buttonOpen
                )}
                onClick={triggerToggle}
            >
                {!toggle ? 
                    <Navigation />
                :
                    <Close />
                }
            </div>

            {toggle &&
                <Menu>
                    <div className={styles.menu}>
                        <nav className={styles.nav}>
                            <ul className={styles.list}>
                                {links.map(link =>
                                    <li 
                                        className={styles.listItem}
                                        key={link.url}
                                    >
                                        <Link
                                            to={link.url}
                                            className={styles.link}
                                            activeClassName={styles.active}
                                        >
                                            {link.name}
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </nav>
                        <div className={styles.social}>
                            <DiscordLink
                                className={styles.socialLink}
                            >
                                <DiscordIcon />
                            </DiscordLink>
                        </div>
                    </div>
                    <Copyright
                        className={styles.copyright}
                    />
                </Menu>
            }
        </header>
    );
};
    
Header.propTypes = {
    link: PropTypes.array
};

Header.defaultProps = {
    
};
